import React from 'react'

function ShirtsImages() {


    return (
        <div className='shirt-image'>
            <img src="https://www.beyoung.in/api/catalog/homepage-3-10/banner-new/11bhuvan-section-desktop-view-min.jpeg" alt="catalog" />
            <img src="https://www.beyoung.in/api/catalog/homepage-3-10/bbimages/new/shop-the-look-desktop-view.jpg" alt="shop-look" />

        </div>
    )
}

export default ShirtsImages;